// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-bc553f62] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.app-sidebar__tab[data-v-bc553f62] {
  display: none;
  padding: 10px;
  min-height: 100%;
  max-height: 100%;
  height: 100%;
  overflow: auto;
}
.app-sidebar__tab[data-v-bc553f62]:focus {
  border-color: var(--color-primary-element);
  box-shadow: 0 0 0.2em var(--color-primary-element);
  outline: 0;
}
.app-sidebar__tab--active[data-v-bc553f62] {
  display: block;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAppSidebarTab-IcebyGtN.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;AACA;EACE,0CAA0C;EAC1C,kDAAkD;EAClD,UAAU;AACZ;AACA;EACE,cAAc;AAChB","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-bc553f62] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.app-sidebar__tab[data-v-bc553f62] {\n  display: none;\n  padding: 10px;\n  min-height: 100%;\n  max-height: 100%;\n  height: 100%;\n  overflow: auto;\n}\n.app-sidebar__tab[data-v-bc553f62]:focus {\n  border-color: var(--color-primary-element);\n  box-shadow: 0 0 0.2em var(--color-primary-element);\n  outline: 0;\n}\n.app-sidebar__tab--active[data-v-bc553f62] {\n  display: block;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
